import axios from 'axios';
import * as ConversationModels from 'models/conversation';
import * as qs from 'qs';
import dateTime from 'utils/dateTime';
import resolvePath from 'utils/resolvePath';
// Action
const FORWARD = 'conversation/forward';
const BACK = 'conversation/back';
const CHANGE_YEAR = 'conversation/changeYear';
const CHANGE_MONTH = 'conversation/changeMonth';
const CHANGE_TIME_SELECT = 'conversation/changeTimeSelect';
const SELECT_DATE = 'conversation/selectDate';
const SELECT_START_TIME = 'conversation/selectStartTime';
const SELECT_END_TIME = 'conversation/selectEndTime';
const SET_EXPIRE = 'conversation/setExpire';
const SET_TIMER_ID = 'conversation/setTimerId';
const SET_RESERVATION_TYPE = 'conversation/setReservationType';
const SET_CONNECTING = 'conversation/setConnecting';
const SET_IS_ALLOW_OPEN_CONVERSATION_PAGE = 'conversation/setIsAllowOpenConversationPage';
const SET_IS_CONVERSATION_STARTED = 'conversation/setIsStarted';
const CLEAR_CONNECTING = 'conversation/clearConnecting';
const UPDATE_REMAINING_TIME = 'conversation/updateRemainingTime';
const SET_SERVER_TIME = 'conversation/setServerTime';
const CHANGE_CONVERSATION_MODE = 'conversation/changeConversationMode';
const OPEN_CHATS = 'conversation/open';
const CLOSE_CHATS = 'conversation/close';
const SET_CHATS = 'conversation/setChats';
const SET_CURRENT_TOPIC = 'conversation/setCurrentTopic';
const SET_YOU_ARE_LATE = 'conversation/setYouAreLate';
const CLEAR_YOU_ARE_LATE = 'conversation/clearYouAreLate';
const SET_OPEN = 'conversation/setOpen';
const SET_REMOTE_ONLINE_STATUS = 'conversation/setRemoteOnlineStatus';
const SET_REMOTE_JOINED_STATUS = 'conversation/setRemoteJoinedStatus';
const SET_NETWORK_QUALITY = 'conversation/setNetworkQuality';
const SET_PARTNER_NETWORK_QUALITY = 'conversation/setPartnerNetworkQuality';
const RESET_RECOMMENDED_RESERVATIONS = 'conversation/resetRecommendedReservations';
const SET_EVALUATION = 'conversation/setEvaluation';
const POST_CONVERSATIONS_REQUEST = 'conversation/postConversationsRequest';
const POST_CONVERSATIONS_SUCCESS = 'conversation/postConversationsSuccess';
const POST_CONVERSATIONS_FAILURE = 'conversation/postConversationsFailure';
const GET_CONVERSATIONS_REQUEST = 'conversation/getConversationsRequest';
const GET_CONVERSATIONS_SUCCESS = 'conversation/getConversationsSuccess';
const GET_CONVERSATIONS_FAILURE = 'conversation/getConversationsFailure';
const GET_CONVERSATIONS_ID_REQUEST = 'conversation/getConversationsIdRequest';
const GET_CONVERSATIONS_ID_SUCCESS = 'conversation/getConversationsIdSuccess';
const GET_CONVERSATIONS_ID_FAILURE = 'conversation/getConversationsIdFailure';
const GET_REQUEST_CONVERSATIONS_ID_REQUEST = 'conversation/getRequestConversationsIdRequest';
const GET_REQUEST_CONVERSATIONS_ID_SUCCESS = 'conversation/getRequestConversationsIdSuccess';
const GET_REQUEST_CONVERSATIONS_ID_FAILURE = 'conversation/getRequestConversationsIdFailure';
const GET_CANCELLED_CONVERSATIONS_ID_REQUEST = 'conversation/getCancelledConversationsIdRequest';
const GET_CANCELLED_CONVERSATIONS_ID_SUCCESS = 'conversation/getCancelledConversationsIdSuccess';
const GET_CANCELLED_CONVERSATIONS_ID_FAILURE = 'conversation/getCancelledConversationsIdFailure';
const CLEAR_CONVERSATIONS_ID = 'conversation/clearConversationsId';
const CLEAR_CANCELLED_CONVERSATIONS_ID = 'conversation/clearCancelledConversationsId';
const DELETE_CONVERSATIONS_REQUEST = 'conversation/deleteConversationsRequest';
const DELETE_CONVERSATIONS_SUCCESS = 'conversation/deleteConversationsSuccess';
const DELETE_CONVERSATIONS_FAILURE = 'conversation/deleteConversationsFailure';
const POST_CONVERSATIONS_EVALUATE_REQUEST = 'conversation/postConversationsEvaluateRequest';
const POST_CONVERSATIONS_EVALUATE_SUCCESS = 'conversation/postConversationsEvaluateSuccess';
const POST_CONVERSATIONS_EVALUATE_FAILURE = 'conversation/postConversationsEvaluateFailure';
const PATCH_CONVERSATIONS_EVALUATE_REQUEST = 'conversation/patchConversationsEvaluateRequest';
const PATCH_CONVERSATIONS_EVALUATE_SUCCESS = 'conversation/patchConversationsEvaluateSuccess';
const PATCH_CONVERSATIONS_EVALUATE_FAILURE = 'conversation/patchConversationsEvaluateFailure';
const POST_CONVERSATIONS_MEMO_REQUEST = 'conversation/postConversationsMemoRequest';
const POST_CONVERSATIONS_MEMO_SUCCESS = 'conversation/postConversationsMemoSuccess';
const POST_CONVERSATIONS_MEMO_FAILURE = 'conversation/postConversationsMemoFailure';
const PATCH_CONVERSATIONS_MEMO_REQUEST = 'conversation/patchConversationsMemoRequest';
const PATCH_CONVERSATIONS_MEMO_SUCCESS = 'conversation/patchConversationsMemoSuccess';
const PATCH_CONVERSATIONS_MEMO_FAILURE = 'conversation/patchConversationsMemoFailure';
const POST_CONVERSATIONS_REPORT_REQUEST = 'conversation/postConversationsReportRequest';
const POST_CONVERSATIONS_REPORT_SUCCESS = 'conversation/postConversationsReportSuccess';
const POST_CONVERSATIONS_REPORT_FAILURE = 'conversation/postConversationsReportFailure';
const PATCH_CONVERSATIONS_REPORT_REQUEST = 'conversation/patchConversationsReportRequest';
const PATCH_CONVERSATIONS_REPORT_SUCCESS = 'conversation/patchConversationsReportSuccess';
const PATCH_CONVERSATIONS_REPORT_FAILURE = 'conversation/patchConversationsReportFailure';
const GET_CALENDAR_REQUEST = 'conversation/getCalendarRequest';
const GET_CALENDAR_SUCCESS = 'conversation/getCalendarSuccess';
const GET_CALENDAR_FAILURE = 'conversation/getCalendarFailure';
const GET_RECOMMEND_REQUEST = 'conversation/getRecommendRequest';
const GET_RECOMMEND_SUCCESS = 'conversation/getRecommendSuccess';
const GET_RECOMMEND_FAILURE = 'conversation/getRecommendFailure';
const GET_RECOMMEND_ID_REQUEST = 'conversation/getRecommendIdRequest';
const GET_RECOMMEND_ID_SUCCESS = 'conversation/getRecommendIdSuccess';
const GET_RECOMMEND_ID_FAILURE = 'conversation/getRecommendIdFailure';
const POST_RESERVE_REQUEST = 'conversation/postReserveRequest';
const POST_RESERVE_SUCCESS = 'conversation/postReserveSuccess';
const POST_RESERVE_FAILURE = 'conversation/postReserveFailure';
const POST_REQUEST_CONVERSATIONS_REQUEST = 'conversation/postRequestConversationsRequest';
const POST_REQUEST_CONVERSATIONS_SUCCESS = 'conversation/postRequestConversationsSuccess';
const POST_REQUEST_CONVERSATIONS_FAILURE = 'conversation/postRequestConversationsFailure';
const GET_STUDENTS_REQUEST_CONVERSATIONS_REQUEST = 'conversation/getStudentsRequestConversationsRequest';
const GET_STUDENTS_REQUEST_CONVERSATIONS_SUCCESS = 'conversation/getStudentsRequestConversationsSuccess';
const GET_STUDENTS_REQUEST_CONVERSATIONS_FAILURE = 'conversation/getStudentsRequestConversationsFailure';
const DELETE_REQUEST_CONVERSATIONS_REQUEST = 'conversation/deleteRequestConversationsRequest';
const DELETE_REQUEST_CONVERSATIONS_SUCCESS = 'conversation/deleteRequestConversationsSuccess';
const DELETE_REQUEST_CONVERSATIONS_FAILURE = 'conversation/deleteRequestConversationsFailure';
// 仮。実際はGET_STUDENTS_REQUEST_CONVERSATIONS_ID_REQUEST, SUCCESS, FAILUREのセットで管理するはず。
const GET_STUDENTS_REQUEST_CONVERSATIONS_ID = 'conversation/getStudentsRequestConversationsId';
const CLEAR_STUDENTS_REQUEST_CONVERSATIONS_ID = 'conversation/clearStudentsRequestConversationsId';
const GET_TEACHERS_REQUEST_CONVERSATIONS_REQUEST = 'conversation/getTeachersRequestConversationsRequest';
const GET_TEACHERS_REQUEST_CONVERSATIONS_SUCCESS = 'conversation/getTeachersRequestConversationsSuccess';
const GET_TEACHERS_REQUEST_CONVERSATIONS_FAILURE = 'conversation/getTeachersRequestConversationsFailure';
// 仮。実際はGET_TEACHERS_REQUEST_CONVERSATIONS_ID_REQUEST, SUCCESS, FAILUREのセットで管理するはず。
const GET_TEACHERS_REQUEST_CONVERSATIONS_ID = 'conversation/getTeachersRequestConversationsId';
const CLEAR_TEACHERS_REQUEST_CONVERSATIONS_ID = 'conversation/clearTeachersRequestConversationsId';
const POST_APPROVE_REQUEST_CONVERSATIONS_REQUEST = 'conversation/postApproveRequestConversationsRequest';
const POST_APPROVE_REQUEST_CONVERSATIONS_SUCCESS = 'conversation/postApproveRequestConversationsSuccess';
const POST_APPROVE_REQUEST_CONVERSATIONS_FAILURE = 'conversation/postApproveRequestConversationsFailure';
const GET_TODAY_REQUEST = 'conversation/getTodayRequest';
const GET_TODAY_SUCCESS = 'conversation/getTodaySuccess';
const GET_TODAY_FAILURE = 'conversation/getTodayFailure';
const GET_EVALUATION_CHECK_REQUEST = 'conversation/hasEvaluationRequest';
const GET_EVALUATION_CHECK_SUCCESS = 'conversation/hasEvaluationSuccess';
const GET_EVALUATION_CHECK_FAILURE = 'converastion/hasEvaluationFailure';
const GET_NEXT_RESERVATION_TIME = 'conversation/getNextReservationTime';
export const forward = () => {
    return {
        type: FORWARD,
    };
};
export const back = () => {
    return {
        type: BACK,
    };
};
export const changeYear = (year) => {
    return {
        payload: {
            year,
        },
        type: CHANGE_YEAR,
    };
};
export const changeMonth = (month) => {
    return {
        payload: {
            month,
        },
        type: CHANGE_MONTH,
    };
};
export const changeTimeSelect = (type) => {
    return {
        payload: {
            type,
        },
        type: CHANGE_TIME_SELECT,
    };
};
export const selectDate = (date) => {
    return {
        payload: {
            date,
        },
        type: SELECT_DATE,
    };
};
export const selectStartTime = (time) => {
    return {
        payload: {
            time,
        },
        type: SELECT_START_TIME,
    };
};
export const selectEndTime = (time) => {
    return {
        payload: {
            time,
        },
        type: SELECT_END_TIME,
    };
};
export const setExpire = (expirePreference) => {
    return {
        payload: {
            expirePreference,
        },
        type: SET_EXPIRE,
    };
};
export const setReservationType = (reservationType) => {
    return {
        payload: {
            reservationType,
        },
        type: SET_RESERVATION_TYPE,
    };
};
export const setTimerId = (timerId) => {
    return {
        payload: {
            timerId,
        },
        type: SET_TIMER_ID,
    };
};
export const setConnecting = () => {
    return {
        type: SET_CONNECTING,
    };
};
export const clearConnecting = () => {
    return {
        type: CLEAR_CONNECTING,
    };
};
export const updateRemainingTime = (remainingTime) => {
    return {
        payload: {
            remainingTime,
        },
        type: UPDATE_REMAINING_TIME,
    };
};
export const setServerTime = (serverTime) => {
    return {
        payload: {
            serverTime,
        },
        type: SET_SERVER_TIME,
    };
};
export const changeConversationMode = (conversationMode) => {
    return {
        payload: {
            conversationMode,
        },
        type: CHANGE_CONVERSATION_MODE,
    };
};
export const openChats = () => {
    return {
        type: OPEN_CHATS,
    };
};
export const closeChats = () => {
    return {
        type: CLOSE_CHATS,
    };
};
export const setChats = (chats) => {
    return {
        payload: {
            chats,
        },
        type: SET_CHATS,
    };
};
export const setCurrentTopic = (currentTopic) => {
    return {
        payload: {
            currentTopic,
        },
        type: SET_CURRENT_TOPIC,
    };
};
export const setYouAreLate = () => {
    return {
        type: SET_YOU_ARE_LATE,
    };
};
export const clearYouAreLate = () => {
    return {
        type: CLEAR_YOU_ARE_LATE,
    };
};
export const setConversationOpen = () => {
    return {
        type: SET_OPEN,
    };
};
export const setRemoteOnlineStatus = (remoteOnline) => {
    return {
        type: SET_REMOTE_ONLINE_STATUS,
        payload: {
            remoteOnline,
        },
    };
};
export const setRemoteJoinedStatus = (remoteJoined) => {
    return {
        type: SET_REMOTE_JOINED_STATUS,
        payload: {
            remoteJoined,
        },
    };
};
export const setNetworkQuality = (networkQuality) => {
    return {
        payload: {
            networkQuality,
        },
        type: SET_NETWORK_QUALITY,
    };
};
export const setPartnerNetworkQuality = (networkQuality) => {
    return {
        payload: {
            networkQuality,
        },
        type: SET_PARTNER_NETWORK_QUALITY,
    };
};
export const setIsConversationStarted = (isConversationStarted) => {
    return {
        payload: {
            isConversationStarted,
        },
        type: SET_IS_CONVERSATION_STARTED,
    };
};
export const setIsAllowOpenConversationPage = (isAllowOpenConversationPage) => {
    return {
        payload: {
            isAllowOpenConversationPage,
        },
        type: SET_IS_ALLOW_OPEN_CONVERSATION_PAGE,
    };
};
export const resetRecommendedReservations = () => {
    return {
        type: RESET_RECOMMENDED_RESERVATIONS,
    };
};
export const setEvaluation = (evaluate) => {
    return {
        payload: {
            evaluate,
        },
        type: SET_EVALUATION,
    };
};
export const postConversationsRequest = () => {
    return {
        type: POST_CONVERSATIONS_REQUEST,
    };
};
export const postConversationsSuccess = (response) => {
    return {
        payload: {
            response,
        },
        type: POST_CONVERSATIONS_SUCCESS,
    };
};
export const postConversationsFailure = (error) => {
    return {
        payload: {
            error,
        },
        type: POST_CONVERSATIONS_FAILURE,
    };
};
export const postConversations = (authToken, request) => (dispatch) => {
    dispatch(postConversationsRequest());
    const config = {
        headers: {
            Authorization: `Bearer ${authToken}`,
        },
    };
    return axios
        .post(resolvePath.api('conversations'), request, config)
        .then((response) => dispatch(postConversationsSuccess(response.data)))
        .catch((error) => {
        dispatch(postConversationsFailure(error));
        throw error;
    });
};
export const getConversationsRequest = (preventReload) => {
    return {
        payload: {
            preventReload,
        },
        type: GET_CONVERSATIONS_REQUEST,
    };
};
export const getConversationsSuccess = (response, preventReload) => {
    return {
        payload: {
            reservations: response,
            preventReload,
        },
        type: GET_CONVERSATIONS_SUCCESS,
    };
};
export const getConversationsFailure = (error, preventReload) => {
    return {
        payload: {
            error,
            preventReload,
        },
        type: GET_CONVERSATIONS_FAILURE,
    };
};
export const getConversations = (authToken, parameters, preventReload) => {
    return (dispatch) => {
        dispatch(getConversationsRequest(preventReload));
        const config = {
            headers: {
                Authorization: `Bearer ${authToken}`,
            },
        };
        return axios
            .get(`${resolvePath.api('conversations')}?${qs.stringify(parameters)}`, config)
            .then((response) => dispatch(getConversationsSuccess(response.data, preventReload)))
            .catch((error) => {
            dispatch(getConversationsFailure(error, preventReload));
            throw error;
        });
    };
};
export const getConversationsIdRequest = () => {
    return {
        type: GET_CONVERSATIONS_ID_REQUEST,
    };
};
export const getConversationsIdSuccess = (response) => {
    return {
        payload: {
            conversation: response,
        },
        type: GET_CONVERSATIONS_ID_SUCCESS,
    };
};
export const getConversationsIdFailure = (error) => {
    return {
        payload: {
            error,
        },
        type: GET_CONVERSATIONS_ID_FAILURE,
    };
};
export const getRequestConversationsIdRequest = () => {
    return {
        type: GET_REQUEST_CONVERSATIONS_ID_REQUEST,
    };
};
export const getRequestConversationsIdSuccess = (response) => {
    return {
        payload: {
            requestConversation: response,
        },
        type: GET_REQUEST_CONVERSATIONS_ID_SUCCESS,
    };
};
export const getRequestConversationsIdFailure = (error) => {
    return {
        payload: {
            error,
        },
        type: GET_REQUEST_CONVERSATIONS_ID_FAILURE,
    };
};
export const getCancelledConversationsIdRequest = () => {
    return {
        type: GET_CANCELLED_CONVERSATIONS_ID_REQUEST,
    };
};
export const getCancelledConversationsIdSuccess = (response) => {
    return {
        payload: {
            cancelledConversation: response,
        },
        type: GET_CANCELLED_CONVERSATIONS_ID_SUCCESS,
    };
};
export const getCancelledConversationsIdFailure = (error) => {
    return {
        payload: {
            error,
        },
        type: GET_CANCELLED_CONVERSATIONS_ID_FAILURE,
    };
};
export const getConversationsId = (authToken, id) => {
    return (dispatch) => {
        dispatch(getConversationsIdRequest());
        const config = {
            headers: {
                Authorization: `Bearer ${authToken}`,
            },
        };
        return axios
            .get(`${resolvePath.api(`conversations/${id}`)}`, config)
            .then((response) => dispatch(getConversationsIdSuccess(response.data)))
            .catch((error) => {
            dispatch(getConversationsIdFailure(error));
            throw error;
        });
    };
};
export const getRequestConversationsId = (authToken, id) => {
    return (dispatch) => {
        dispatch(getRequestConversationsIdRequest());
        const config = {
            headers: {
                Authorization: `Bearer ${authToken}`,
            },
        };
        return axios
            .get(`${resolvePath.api(`conversation_requests/${id}`)}`, config)
            .then((response) => dispatch(getRequestConversationsIdSuccess(response.data)))
            .catch((error) => {
            dispatch(getRequestConversationsIdFailure(error));
            throw error;
        });
    };
};
export const clearConversationsId = () => {
    return {
        type: CLEAR_CONVERSATIONS_ID,
    };
};
export const clearCancelledConversationsId = () => {
    return {
        type: CLEAR_CANCELLED_CONVERSATIONS_ID,
    };
};
export const deleteConversationsRequest = () => {
    return {
        type: DELETE_CONVERSATIONS_REQUEST,
    };
};
export const deleteConversationsSuccess = (deletedConversation) => {
    return {
        payload: {
            deletedConversation,
        },
        type: DELETE_CONVERSATIONS_SUCCESS,
    };
};
export const deleteConversationsFailure = (error) => {
    return {
        payload: {
            error,
        },
        type: DELETE_CONVERSATIONS_FAILURE,
    };
};
export const deleteConversations = (authToken, id) => (dispatch) => {
    dispatch(deleteConversationsRequest());
    const config = {
        headers: {
            Authorization: `Bearer ${authToken}`,
        },
    };
    return axios
        .delete(resolvePath.api(`conversations/${id}`), config)
        .then((response) => dispatch(deleteConversationsSuccess(response.data)))
        .catch((error) => {
        dispatch(deleteConversationsFailure(error));
        throw error;
    });
};
export const postConversationsEvaluateRequest = () => {
    return {
        type: POST_CONVERSATIONS_EVALUATE_REQUEST,
    };
};
export const postConversationsEvaluateSuccess = (evaluatedConversation) => {
    return {
        payload: {
            evaluatedConversation,
        },
        type: POST_CONVERSATIONS_EVALUATE_SUCCESS,
    };
};
export const postConversationsEvaluateFailure = (error) => {
    return {
        payload: {
            error,
        },
        type: POST_CONVERSATIONS_EVALUATE_FAILURE,
    };
};
export const postConversationsEvaluate = (authToken, id, evaluate) => (dispatch) => {
    dispatch(postConversationsEvaluateRequest());
    const config = {
        headers: {
            Authorization: `Bearer ${authToken}`,
        },
    };
    const request = Object.assign({}, evaluate);
    return axios
        .post(resolvePath.api(`conversations/${id}/evaluate2`), request, config)
        .then((response) => {
        dispatch(postConversationsEvaluateSuccess(response.data));
    })
        .catch((error) => {
        dispatch(postConversationsEvaluateFailure(error));
        throw error;
    });
};
export const patchConversationsEvaluateRequest = () => {
    return {
        type: PATCH_CONVERSATIONS_EVALUATE_REQUEST,
    };
};
export const patchConversationsEvaluateSuccess = (evaluatedConversation) => {
    return {
        payload: {
            evaluatedConversation,
        },
        type: PATCH_CONVERSATIONS_EVALUATE_SUCCESS,
    };
};
export const patchConversationsEvaluateFailure = (error) => {
    return {
        payload: {
            error,
        },
        type: PATCH_CONVERSATIONS_EVALUATE_FAILURE,
    };
};
export const patchConversationsEvaluate = (authToken, id, evaluate) => (dispatch) => {
    dispatch(patchConversationsEvaluateRequest());
    const config = {
        headers: {
            Authorization: `Bearer ${authToken}`,
        },
    };
    const request = Object.assign({}, evaluate);
    return axios
        .patch(resolvePath.api(`conversations/${id}/evaluate2`), request, config)
        .then((response) => {
        dispatch(patchConversationsEvaluateSuccess(response.data));
    })
        .catch((error) => {
        dispatch(patchConversationsEvaluateFailure(error));
        throw error;
    });
};
export const postConversationsMemoRequest = () => {
    return {
        type: POST_CONVERSATIONS_MEMO_REQUEST,
    };
};
export const postConversationsMemoSuccess = (evaluatedConversation) => {
    return {
        payload: {
            evaluatedConversation,
        },
        type: POST_CONVERSATIONS_MEMO_SUCCESS,
    };
};
export const postConversationsMemoFailure = (error) => {
    return {
        payload: {
            error,
        },
        type: POST_CONVERSATIONS_MEMO_FAILURE,
    };
};
export const postConversationsMemo = (authToken, id, memo, conversation_category) => (dispatch) => {
    dispatch(postConversationsMemoRequest());
    const config = {
        headers: {
            Authorization: `Bearer ${authToken}`,
        },
    };
    const request = {
        memo,
        conversation_category,
    };
    return axios
        .post(resolvePath.api(`conversations/${id}/memo`), request, config)
        .then((response) => {
        dispatch(postConversationsMemoSuccess(response.data));
    })
        .catch((error) => {
        dispatch(postConversationsMemoFailure(error));
        throw error;
    });
};
export const patchConversationsMemoRequest = () => {
    return {
        type: PATCH_CONVERSATIONS_MEMO_REQUEST,
    };
};
export const patchConversationsMemoSuccess = (evaluatedConversation) => {
    return {
        payload: {
            evaluatedConversation,
        },
        type: PATCH_CONVERSATIONS_MEMO_SUCCESS,
    };
};
export const patchConversationsMemoFailure = (error) => {
    return {
        payload: {
            error,
        },
        type: PATCH_CONVERSATIONS_MEMO_FAILURE,
    };
};
export const patchConversationsMemo = (authToken, id, memo, conversation_category) => (dispatch) => {
    dispatch(patchConversationsMemoRequest());
    const config = {
        headers: {
            Authorization: `Bearer ${authToken}`,
        },
    };
    const request = {
        memo,
        conversation_category,
    };
    return axios
        .patch(resolvePath.api(`conversations/${id}/memo`), request, config)
        .then((response) => {
        dispatch(patchConversationsMemoSuccess(response.data));
    })
        .catch((error) => {
        dispatch(patchConversationsMemoFailure(error));
        throw error;
    });
};
export const postConversationsReportRequest = () => {
    return {
        type: POST_CONVERSATIONS_REPORT_REQUEST,
    };
};
export const postConversationsReportSuccess = (evaluatedConversation) => {
    return {
        payload: {
            evaluatedConversation,
        },
        type: POST_CONVERSATIONS_REPORT_SUCCESS,
    };
};
export const postConversationsReportFailure = (error) => {
    return {
        payload: {
            error,
        },
        type: POST_CONVERSATIONS_REPORT_FAILURE,
    };
};
export const postConversationsReport = (authToken, id, reportContent) => (dispatch) => {
    dispatch(postConversationsReportRequest());
    const config = {
        headers: {
            Authorization: `Bearer ${authToken}`,
        },
    };
    const request = {
        report_detail: reportContent.report_detail,
        report_reasons: reportContent.report_reasons,
    };
    return axios
        .post(resolvePath.api(`conversations/${id}/report`), request, config)
        .then((response) => {
        dispatch(postConversationsReportSuccess(response.data));
    })
        .catch((error) => {
        dispatch(postConversationsReportFailure(error));
        throw error;
    });
};
export const patchConversationsReportRequest = () => {
    return {
        type: PATCH_CONVERSATIONS_REPORT_REQUEST,
    };
};
export const patchConversationsReportSuccess = (evaluatedConversation) => {
    return {
        payload: {
            evaluatedConversation,
        },
        type: PATCH_CONVERSATIONS_REPORT_SUCCESS,
    };
};
export const patchConversationsReportFailure = (error) => {
    return {
        payload: {
            error,
        },
        type: PATCH_CONVERSATIONS_REPORT_FAILURE,
    };
};
export const patchConversationsReport = (authToken, id, reportContent) => (dispatch) => {
    dispatch(patchConversationsReportRequest());
    const config = {
        headers: {
            Authorization: `Bearer ${authToken}`,
        },
    };
    const request = {
        report_detail: reportContent.report_detail,
        report_reasons: reportContent.report_reasons,
    };
    return axios
        .patch(resolvePath.api(`conversations/${id}/report`), request, config)
        .then((response) => {
        dispatch(patchConversationsReportSuccess(response.data));
    })
        .catch((error) => {
        dispatch(patchConversationsReportFailure(error));
        throw error;
    });
};
export const getCalendarRequest = () => {
    return {
        type: GET_CALENDAR_REQUEST,
    };
};
export const getCalendarSuccess = (calendar) => {
    return {
        payload: {
            calendar,
        },
        type: GET_CALENDAR_SUCCESS,
    };
};
export const getCalendarFailure = (error) => {
    return {
        payload: {
            error,
        },
        type: GET_CALENDAR_FAILURE,
    };
};
export const getCalendar = (authToken, year, month) => (dispatch) => {
    dispatch(getCalendarRequest());
    const config = {
        headers: {
            Authorization: `Bearer ${authToken}`,
        },
    };
    const request = {
        month,
        year,
    };
    return axios
        .get(`${resolvePath.api('conversations/calendar')}?${qs.stringify(request)}`, config)
        .then((response) => dispatch(getCalendarSuccess(response.data)))
        .catch((error) => {
        dispatch(getCalendarFailure(error));
        throw error;
    });
};
export const getRecommendRequest = () => {
    return {
        type: GET_RECOMMEND_REQUEST,
    };
};
export const getRecommendSuccess = (recommendedReservations) => {
    return {
        payload: {
            recommendedReservations,
        },
        type: GET_RECOMMEND_SUCCESS,
    };
};
export const getRecommendFailure = (error) => {
    return {
        payload: {
            error,
        },
        type: GET_RECOMMEND_FAILURE,
    };
};
export const getRecommend = (authToken, date) => (dispatch) => {
    dispatch(getRecommendRequest());
    const config = {
        headers: {
            Authorization: `Bearer ${authToken}`,
        },
    };
    const request = {
        date_on: date,
    };
    return axios
        .get(`${resolvePath.api('conversations/recommend')}?${qs.stringify(request)}`, config)
        .then((response) => dispatch(getRecommendSuccess(response.data)))
        .catch((error) => {
        dispatch(getRecommendFailure(error));
        throw error;
    });
};
export const getRecommendNew = (authToken, date, syspcurrentppage) => (dispatch) => {
    dispatch(getRecommendRequest());
    const config = {
        headers: {
            Authorization: `Bearer ${authToken}`,
        },
    };
    const request = {
        date_on: date,
        syspcurrentpage: syspcurrentppage,
    };
    return axios
        .get(`${resolvePath.api('conversations/recommend')}?${qs.stringify(request)}`, config)
        .then((response) => dispatch(getRecommendSuccess(response.data)))
        .catch((error) => {
        dispatch(getRecommendFailure(error));
        throw error;
    });
};
export const getRecommendIdRequest = () => {
    return {
        type: GET_RECOMMEND_ID_REQUEST,
    };
};
export const getRecommendIdSuccess = (recommendedReservation) => {
    return {
        payload: {
            recommendedReservation,
        },
        type: GET_RECOMMEND_ID_SUCCESS,
    };
};
export const getRecommendIdFailure = (error) => {
    return {
        payload: {
            error,
        },
        type: GET_RECOMMEND_ID_FAILURE,
    };
};
export const getRecommendId = (authToken, id) => (dispatch) => {
    dispatch(getRecommendIdRequest());
    const config = {
        headers: {
            Authorization: `Bearer ${authToken}`,
        },
    };
    return axios
        .get(resolvePath.api(`conversations/recommend/${id}`), config)
        .then((response) => dispatch(getRecommendIdSuccess(response.data)))
        .catch((error) => {
        dispatch(getRecommendIdFailure(error));
        throw error;
    });
};
export const postReserveRequest = () => {
    return {
        type: POST_RESERVE_REQUEST,
    };
};
export const postReserveSuccess = (reservedConversation) => {
    return {
        payload: {
            reservedConversation,
        },
        type: POST_RESERVE_SUCCESS,
    };
};
export const postReserveFailure = (error) => {
    return {
        payload: {
            error,
        },
        type: POST_RESERVE_FAILURE,
    };
};
export const postReserve = (authToken, conversationId) => (dispatch) => {
    dispatch(postReserveRequest());
    const config = {
        headers: {
            Authorization: `Bearer ${authToken}`,
        },
    };
    const request = {
        id: conversationId,
    };
    return axios
        .post(resolvePath.api('conversations/reserve'), request, config)
        .then((response) => {
        dispatch(postReserveSuccess(response.data));
        dispatch(resetRecommendedReservations());
    })
        .catch((error) => {
        dispatch(postReserveFailure(error));
        throw error;
    });
};
export const getCancelledConversationsId = (authToken, id) => {
    return (dispatch) => {
        dispatch(getConversationsIdRequest());
        const config = {
            headers: {
                Authorization: `Bearer ${authToken}`,
            },
        };
        return axios
            .get(`${resolvePath.api(`conversations/cancelled/${id}`)}`, config)
            .then((response) => dispatch(getCancelledConversationsIdSuccess(response.data)))
            .catch((error) => {
            dispatch(getConversationsIdFailure(error));
            throw error;
        });
    };
};
export const postRequestConversationsRequest = () => {
    return {
        type: POST_REQUEST_CONVERSATIONS_REQUEST,
    };
};
export const postRequestConversationsSuccess = (reservedConversation) => {
    return {
        payload: {
            reservedConversation,
        },
        type: POST_REQUEST_CONVERSATIONS_SUCCESS,
    };
};
export const postRequestConversationsFailure = (error) => {
    return {
        payload: {
            error,
        },
        type: POST_REQUEST_CONVERSATIONS_FAILURE,
    };
};
export const postRequestConversations = (authToken, conversationId, startAt) => (dispatch) => {
    dispatch(postRequestConversationsRequest());
    const config = {
        headers: {
            Authorization: `Bearer ${authToken}`,
        },
    };
    const request = {
        reservable_conversation_id: conversationId,
        start_at: startAt,
    };
    return axios
        .post(resolvePath.api(`conversation_requests`), request, config)
        .then((response) => {
        dispatch(postRequestConversationsSuccess(response.data.conversation));
        dispatch(resetRecommendedReservations());
    })
        .catch((error) => {
        dispatch(postRequestConversationsFailure(error));
        throw error;
    });
};
export const getStudentsRequestConversationsRequest = () => {
    return {
        type: GET_STUDENTS_REQUEST_CONVERSATIONS_REQUEST,
    };
};
export const getStudentsRequestConversationsSuccess = (studentsRequestConversations) => {
    return {
        payload: {
            studentsRequestConversations,
        },
        type: GET_STUDENTS_REQUEST_CONVERSATIONS_SUCCESS,
    };
};
export const getStudentsRequestConversationsFailure = (error) => {
    return {
        payload: {
            error,
        },
        type: GET_STUDENTS_REQUEST_CONVERSATIONS_FAILURE,
    };
};
export const getStudentsRequestConversations = (authToken) => (dispatch) => {
    dispatch(getStudentsRequestConversationsRequest());
    const config = {
        headers: {
            Authorization: `Bearer ${authToken}`,
        },
    };
    return axios
        .get(resolvePath.api('conversation_requests'), config)
        .then((response) => dispatch(getStudentsRequestConversationsSuccess(response.data)))
        .catch((error) => {
        dispatch(getStudentsRequestConversationsFailure(error));
        throw error;
    });
};
export const deleteRequestConversationsRequest = () => {
    return {
        type: DELETE_REQUEST_CONVERSATIONS_REQUEST,
    };
};
export const deleteRequestConversationsSuccess = (deletedRequestConversation) => {
    return {
        payload: {
            deletedRequestConversation,
        },
        type: DELETE_REQUEST_CONVERSATIONS_SUCCESS,
    };
};
export const deleteRequestConversationsFailure = (error) => {
    return {
        payload: {
            error,
        },
        type: DELETE_REQUEST_CONVERSATIONS_FAILURE,
    };
};
export const deleteRequestConversations = (authToken, id) => (dispatch) => {
    dispatch(deleteRequestConversationsRequest());
    const config = {
        headers: {
            Authorization: `Bearer ${authToken}`,
        },
    };
    return axios
        .delete(resolvePath.api(`conversation_requests/${id}`), config)
        .then((response) => dispatch(deleteRequestConversationsSuccess(response.data)))
        .catch((error) => {
        dispatch(deleteRequestConversationsFailure(error));
        throw error;
    });
};
export const getStudentsRequestConversationsId = (studentsRequestConversation) => {
    return {
        payload: {
            studentsRequestConversation,
        },
        type: GET_STUDENTS_REQUEST_CONVERSATIONS_ID,
    };
};
export const clearStudentsRequestConversationsId = () => {
    return {
        type: CLEAR_STUDENTS_REQUEST_CONVERSATIONS_ID,
    };
};
export const getTeachersRequestConversationsRequest = () => {
    return {
        type: GET_TEACHERS_REQUEST_CONVERSATIONS_REQUEST,
    };
};
export const getTeachersRequestConversationsSuccess = (teachersRequestConversations) => {
    return {
        payload: {
            teachersRequestConversations,
        },
        type: GET_TEACHERS_REQUEST_CONVERSATIONS_SUCCESS,
    };
};
export const getTeachersRequestConversationsFailure = (error) => {
    return {
        payload: {
            error,
        },
        type: GET_TEACHERS_REQUEST_CONVERSATIONS_FAILURE,
    };
};
export const getTeachersRequestConversations = (authToken) => (dispatch) => {
    dispatch(getTeachersRequestConversationsRequest());
    const config = {
        headers: {
            Authorization: `Bearer ${authToken}`,
        },
    };
    return axios
        .get(resolvePath.api('conversations/requests_from_students'), config)
        .then((response) => dispatch(getTeachersRequestConversationsSuccess(response.data)))
        .catch((error) => {
        dispatch(getTeachersRequestConversationsFailure(error));
        throw error;
    });
};
export const getTeachersRequestConversationsId = (teachersRequestConversation) => {
    return {
        payload: {
            teachersRequestConversation,
        },
        type: GET_TEACHERS_REQUEST_CONVERSATIONS_ID,
    };
};
export const clearTeachersRequestConversationsId = () => {
    return {
        type: CLEAR_TEACHERS_REQUEST_CONVERSATIONS_ID,
    };
};
export const postApproveRequestConversationsRequest = () => {
    return {
        type: POST_APPROVE_REQUEST_CONVERSATIONS_REQUEST,
    };
};
export const postApproveRequestConversationsSuccess = (teachersRequestConversation) => {
    return {
        payload: {
            teachersRequestConversation,
        },
        type: POST_APPROVE_REQUEST_CONVERSATIONS_SUCCESS,
    };
};
export const postApproveRequestConversationsFailure = (error) => {
    return {
        payload: {
            error,
        },
        type: POST_APPROVE_REQUEST_CONVERSATIONS_FAILURE,
    };
};
export const postApproveRequestConversations = (authToken, conversationRequestId) => (dispatch) => {
    dispatch(postApproveRequestConversationsRequest());
    const config = {
        headers: {
            Authorization: `Bearer ${authToken}`,
        },
    };
    return axios
        .patch(resolvePath.api(`conversation_requests/${conversationRequestId}`), null, config)
        .then((response) => dispatch(postApproveRequestConversationsSuccess(response.data)))
        .catch((error) => {
        dispatch(postApproveRequestConversationsFailure(error));
        throw error;
    });
};
export const postStartConversation = (authToken, conversationId) => {
    const config = {
        headers: {
            Authorization: `Bearer ${authToken}`,
        },
    };
    return axios.post(resolvePath.api(`conversations/${conversationId}/start`), null, config);
};
export const postProgressConversation = (authToken, conversationId) => {
    const config = {
        headers: {
            Authorization: `Bearer ${authToken}`,
        },
    };
    return axios.post(resolvePath.api(`conversations/${conversationId}/progress`), null, config);
};
export const getTodayRequest = () => {
    return {
        type: GET_TODAY_REQUEST,
    };
};
export const getTodaySuccess = (response) => {
    return {
        payload: {
            todayConversations: response.data,
        },
        type: GET_TODAY_SUCCESS,
    };
};
export const getTodayFailure = (error) => {
    return {
        payload: {
            error,
        },
        type: GET_TODAY_FAILURE,
    };
};
export const getToday = (authToken) => {
    return (dispatch) => {
        dispatch(getTodayRequest());
        const config = {
            headers: {
                Authorization: `Bearer ${authToken}`,
            },
        };
        return axios
            .get(`${resolvePath.api(`conversations/today`)}`, config)
            .then((response) => dispatch(getTodaySuccess(response.data)))
            .catch((error) => {
            dispatch(getTodayFailure(error));
            throw error;
        });
    };
};
export const getEvaluationCheckRequest = () => {
    return {
        type: GET_EVALUATION_CHECK_REQUEST,
    };
};
export const getEvaluationCheckSuccess = (response) => {
    return {
        payload: {
            hasEvaluation: response.data,
        },
        type: GET_EVALUATION_CHECK_SUCCESS,
    };
};
export const getEvaluationCheckFailure = (error) => {
    return {
        payload: {
            error,
        },
        type: GET_EVALUATION_CHECK_FAILURE,
    };
};
export const getEvaluationCheck = (authToken, userId, conversationId) => {
    return (dispatch) => {
        dispatch(getEvaluationCheckRequest());
        const config = {
            headers: {
                Authorization: `Bearer ${authToken}`,
            },
            params: {
                user_id: userId,
                conversation_id: conversationId,
            },
        };
        return axios
            .get(`${resolvePath.api(`conversations/has_evaluation`)}`, config)
            .then((response) => {
            dispatch(getEvaluationCheckSuccess(response.data));
        })
            .catch((error) => {
            dispatch(getEvaluationCheckFailure(error));
            throw error;
        });
    };
};
export const getNextReservationTime = (hour, minute) => {
    const [newStartTime, newEndTime] = dateTime.getNextReservationTime(hour, minute);
    return {
        payload: {
            startTime: newStartTime,
            endTime: newEndTime,
        },
        type: GET_NEXT_RESERVATION_TIME,
    };
};
const initialState = {
    networkQuality: 3,
    partnerNetworkQuality: 0,
    isPartnerAudioMuted: false,
    isConversationStarted: false,
    isAllowOpenConversationPage: false,
    isPartnerVideoMuted: false,
    calendar: {},
    cancelledConversation: null,
    chats: [],
    conversation: null,
    conversationMode: 'video',
    currentTopic: '',
    deletedConversation: null,
    deletedRequestConversation: null,
    endTime: '14:55',
    error: undefined,
    evaluate: null,
    evaluatedConversation: null,
    expirePreference: ConversationModels.ExpirePreference.Never,
    expireTime: '10:00',
    isConnecting: false,
    fetching: 0,
    memo: '',
    conversation_category: -1,
    page: 1,
    open: false,
    recommendedReservation: null,
    recommendedReservations: [],
    remainingTime: '',
    remoteJoined: false,
    remoteOnline: false,
    requestConversation: null,
    reservations: null,
    reservationType: 'anyone',
    reservedConversation: null,
    response: null,
    selectedDate: '',
    selectedMonth: 1,
    selectedYear: 1970,
    serverTime: null,
    startTime: '10:00',
    studentsRequestConversation: null,
    studentsRequestConversations: null,
    teachersRequestConversation: null,
    teachersRequestConversations: [],
    timeSelect: 'zone',
    topics: {},
    youAreLate: false,
    todayConversations: [],
    hasEvaluation: false,
    timerId: 0,
};
export default (state = initialState, action) => {
    switch (action.type) {
        case FORWARD: {
            return Object.assign(Object.assign({}, state), { page: state.page + 1 });
        }
        case BACK: {
            return Object.assign(Object.assign({}, state), { page: state.page - 1 });
        }
        case CHANGE_YEAR: {
            return Object.assign(Object.assign({}, state), { selectedYear: action.payload.year });
        }
        case CHANGE_MONTH: {
            return Object.assign(Object.assign({}, state), { selectedMonth: action.payload.month });
        }
        case CHANGE_TIME_SELECT: {
            return Object.assign(Object.assign({}, state), { timeSelect: action.payload.type });
        }
        case SELECT_DATE: {
            return Object.assign(Object.assign({}, state), { selectedDate: action.payload.date });
        }
        case SELECT_START_TIME: {
            return Object.assign(Object.assign({}, state), { startTime: action.payload.time });
        }
        case SELECT_END_TIME: {
            return Object.assign(Object.assign({}, state), { endTime: action.payload.time });
        }
        case SET_EXPIRE: {
            return Object.assign(Object.assign({}, state), { expirePreference: action.payload.expirePreference });
        }
        case SET_RESERVATION_TYPE: {
            return Object.assign(Object.assign({}, state), { reservationType: action.payload.reservationType });
        }
        case SET_CONNECTING: {
            return Object.assign(Object.assign({}, state), { isConnecting: true });
        }
        case CLEAR_CONNECTING: {
            return Object.assign(Object.assign({}, state), { isConnecting: false });
        }
        case UPDATE_REMAINING_TIME: {
            return Object.assign(Object.assign({}, state), { remainingTime: action.payload.remainingTime });
        }
        case SET_SERVER_TIME: {
            return Object.assign(Object.assign({}, state), { serverTime: Object.assign({}, action.payload.serverTime) });
        }
        case CHANGE_CONVERSATION_MODE: {
            return Object.assign(Object.assign({}, state), { conversationMode: action.payload.conversationMode });
        }
        case OPEN_CHATS: {
            return Object.assign(Object.assign({}, state), { isOpened: true });
        }
        case CLOSE_CHATS: {
            return Object.assign(Object.assign({}, state), { isOpened: false });
        }
        case SET_CHATS: {
            return Object.assign(Object.assign({}, state), { chats: action.payload.chats });
        }
        case SET_CURRENT_TOPIC: {
            return Object.assign(Object.assign({}, state), { currentTopic: action.payload.currentTopic });
        }
        case SET_YOU_ARE_LATE: {
            return Object.assign(Object.assign({}, state), { youAreLate: true });
        }
        case CLEAR_YOU_ARE_LATE: {
            return Object.assign(Object.assign({}, state), { youAreLate: false });
        }
        case SET_OPEN: {
            return Object.assign(Object.assign({}, state), { open: true });
        }
        case SET_REMOTE_JOINED_STATUS: {
            return Object.assign(Object.assign({}, state), { remoteJoined: action.payload.remoteJoined });
        }
        case SET_REMOTE_ONLINE_STATUS: {
            return Object.assign(Object.assign({}, state), { remoteOnline: action.payload.remoteOnline });
        }
        case SET_NETWORK_QUALITY: {
            return Object.assign(Object.assign({}, state), { networkQuality: action.payload.networkQuality });
        }
        case SET_PARTNER_NETWORK_QUALITY: {
            return Object.assign(Object.assign({}, state), { partnerNetworkQuality: action.payload.networkQuality });
        }
        case SET_IS_CONVERSATION_STARTED: {
            return Object.assign(Object.assign({}, state), { isConversationStarted: action.payload.isConversationStarted });
        }
        case SET_IS_ALLOW_OPEN_CONVERSATION_PAGE: {
            return Object.assign(Object.assign({}, state), { isAllowOpenConversationPage: action.payload.isAllowOpenConversationPage });
        }
        case RESET_RECOMMENDED_RESERVATIONS: {
            return Object.assign(Object.assign({}, state), { recommendedReservations: [] });
        }
        case SET_EVALUATION: {
            return Object.assign(Object.assign({}, state), { evaluate: action.payload.evaluate });
        }
        case POST_CONVERSATIONS_REQUEST: {
            return Object.assign(Object.assign({}, state), { fetching: state.fetching + 1 });
        }
        case POST_CONVERSATIONS_SUCCESS: {
            return Object.assign(Object.assign({}, state), { fetching: state.fetching > 0 ? state.fetching - 1 : 0, response: action.payload.response });
        }
        case POST_CONVERSATIONS_FAILURE: {
            return Object.assign(Object.assign({}, state), { error: action.payload.error, fetching: state.fetching > 0 ? state.fetching - 1 : 0 });
        }
        case GET_CONVERSATIONS_REQUEST: {
            return Object.assign(Object.assign({}, state), { fetching: action.payload.preventReload ? 0 : state.fetching + 1 });
        }
        case GET_CONVERSATIONS_SUCCESS: {
            return Object.assign(Object.assign({}, state), { fetching: action.payload.preventReload ? 0 : state.fetching > 0 ? state.fetching - 1 : 0, reservations: Object.assign({}, action.payload.reservations) });
        }
        case GET_CONVERSATIONS_FAILURE: {
            return Object.assign(Object.assign({}, state), { error: action.payload.error, fetching: action.payload.preventReload ? 0 : state.fetching > 0 ? state.fetching - 1 : 0 });
        }
        case GET_CONVERSATIONS_ID_REQUEST: {
            return Object.assign(Object.assign({}, state), { fetching: state.fetching + 1 });
        }
        case GET_CONVERSATIONS_ID_SUCCESS: {
            return Object.assign(Object.assign({}, state), { conversation: Object.assign({}, action.payload.conversation), fetching: state.fetching > 0 ? state.fetching - 1 : 0 });
        }
        case GET_CONVERSATIONS_ID_FAILURE: {
            return Object.assign(Object.assign({}, state), { error: action.payload.error, fetching: state.fetching > 0 ? state.fetching - 1 : 0 });
        }
        case GET_REQUEST_CONVERSATIONS_ID_REQUEST: {
            return Object.assign(Object.assign({}, state), { fetching: state.fetching + 1 });
        }
        case GET_REQUEST_CONVERSATIONS_ID_SUCCESS: {
            return Object.assign(Object.assign({}, state), { requestConversation: Object.assign({}, action.payload.requestConversation), fetching: state.fetching > 0 ? state.fetching - 1 : 0 });
        }
        case GET_REQUEST_CONVERSATIONS_ID_FAILURE: {
            return Object.assign(Object.assign({}, state), { error: action.payload.error, fetching: state.fetching > 0 ? state.fetching - 1 : 0 });
        }
        case GET_CANCELLED_CONVERSATIONS_ID_REQUEST: {
            return Object.assign(Object.assign({}, state), { fetching: state.fetching + 1 });
        }
        case GET_CANCELLED_CONVERSATIONS_ID_SUCCESS: {
            return Object.assign(Object.assign({}, state), { cancelledConversation: Object.assign({}, action.payload.cancelledConversation), fetching: state.fetching > 0 ? state.fetching - 1 : 0 });
        }
        case GET_CANCELLED_CONVERSATIONS_ID_FAILURE: {
            return Object.assign(Object.assign({}, state), { error: action.payload.error, fetching: state.fetching > 0 ? state.fetching - 1 : 0 });
        }
        case CLEAR_CONVERSATIONS_ID: {
            return Object.assign(Object.assign({}, state), { conversation: null });
        }
        case CLEAR_CANCELLED_CONVERSATIONS_ID: {
            return Object.assign(Object.assign({}, state), { cancelledConversation: null });
        }
        case DELETE_CONVERSATIONS_REQUEST: {
            return Object.assign(Object.assign({}, state), { fetching: state.fetching + 1 });
        }
        case DELETE_CONVERSATIONS_SUCCESS: {
            return Object.assign(Object.assign({}, state), { deletedConversation: Object.assign({}, action.payload.deletedConversation), fetching: state.fetching > 0 ? state.fetching - 1 : 0 });
        }
        case DELETE_CONVERSATIONS_FAILURE: {
            return Object.assign(Object.assign({}, state), { error: action.payload.error, fetching: state.fetching > 0 ? state.fetching - 1 : 0 });
        }
        case POST_CONVERSATIONS_EVALUATE_REQUEST: {
            return Object.assign(Object.assign({}, state), { fetching: state.fetching + 1 });
        }
        case POST_CONVERSATIONS_EVALUATE_SUCCESS: {
            return Object.assign(Object.assign({}, state), { evaluatedConversation: Object.assign({}, action.payload.evaluatedConversation), fetching: state.fetching > 0 ? state.fetching - 1 : 0 });
        }
        case POST_CONVERSATIONS_EVALUATE_FAILURE: {
            return Object.assign(Object.assign({}, state), { error: action.payload.error, fetching: state.fetching > 0 ? state.fetching - 1 : 0 });
        }
        case PATCH_CONVERSATIONS_EVALUATE_REQUEST: {
            return Object.assign(Object.assign({}, state), { fetching: state.fetching + 1 });
        }
        case PATCH_CONVERSATIONS_EVALUATE_SUCCESS: {
            return Object.assign(Object.assign({}, state), { evaluatedConversation: Object.assign({}, action.payload.evaluatedConversation), fetching: state.fetching > 0 ? state.fetching - 1 : 0 });
        }
        case PATCH_CONVERSATIONS_EVALUATE_FAILURE: {
            return Object.assign(Object.assign({}, state), { error: action.payload.error, fetching: state.fetching > 0 ? state.fetching - 1 : 0 });
        }
        case POST_CONVERSATIONS_MEMO_REQUEST: {
            return Object.assign(Object.assign({}, state), { fetching: state.fetching + 1 });
        }
        case POST_CONVERSATIONS_MEMO_SUCCESS: {
            return Object.assign(Object.assign({}, state), { evaluatedConversation: Object.assign({}, action.payload.evaluatedConversation), fetching: state.fetching > 0 ? state.fetching - 1 : 0 });
        }
        case POST_CONVERSATIONS_MEMO_FAILURE: {
            return Object.assign(Object.assign({}, state), { error: action.payload.error, fetching: state.fetching > 0 ? state.fetching - 1 : 0 });
        }
        case PATCH_CONVERSATIONS_MEMO_REQUEST: {
            return Object.assign(Object.assign({}, state), { fetching: state.fetching + 1 });
        }
        case PATCH_CONVERSATIONS_MEMO_SUCCESS: {
            return Object.assign(Object.assign({}, state), { evaluatedConversation: Object.assign({}, action.payload.evaluatedConversation), fetching: state.fetching > 0 ? state.fetching - 1 : 0 });
        }
        case PATCH_CONVERSATIONS_MEMO_FAILURE: {
            return Object.assign(Object.assign({}, state), { error: action.payload.error, fetching: state.fetching > 0 ? state.fetching - 1 : 0 });
        }
        case POST_CONVERSATIONS_REPORT_REQUEST: {
            return Object.assign(Object.assign({}, state), { fetching: state.fetching + 1 });
        }
        case POST_CONVERSATIONS_REPORT_SUCCESS: {
            return Object.assign(Object.assign({}, state), { evaluatedConversation: Object.assign({}, action.payload.evaluatedConversation), fetching: state.fetching > 0 ? state.fetching - 1 : 0 });
        }
        case POST_CONVERSATIONS_REPORT_FAILURE: {
            return Object.assign(Object.assign({}, state), { error: action.payload.error, fetching: state.fetching > 0 ? state.fetching - 1 : 0 });
        }
        case PATCH_CONVERSATIONS_REPORT_REQUEST: {
            return Object.assign(Object.assign({}, state), { fetching: state.fetching + 1 });
        }
        case PATCH_CONVERSATIONS_REPORT_SUCCESS: {
            return Object.assign(Object.assign({}, state), { evaluatedConversation: Object.assign({}, action.payload.evaluatedConversation), fetching: state.fetching > 0 ? state.fetching - 1 : 0 });
        }
        case PATCH_CONVERSATIONS_REPORT_FAILURE: {
            return Object.assign(Object.assign({}, state), { error: action.payload.error, fetching: state.fetching > 0 ? state.fetching - 1 : 0 });
        }
        case GET_CALENDAR_REQUEST: {
            return Object.assign(Object.assign({}, state), { fetching: state.fetching + 1 });
        }
        case GET_CALENDAR_SUCCESS: {
            return Object.assign(Object.assign({}, state), { calendar: Object.assign({}, action.payload.calendar), fetching: state.fetching > 0 ? state.fetching - 1 : 0 });
        }
        case GET_CALENDAR_FAILURE: {
            return Object.assign(Object.assign({}, state), { error: action.payload.error, fetching: state.fetching > 0 ? state.fetching - 1 : 0 });
        }
        case GET_RECOMMEND_REQUEST: {
            return Object.assign(Object.assign({}, state), { fetching: state.fetching + 1 });
        }
        case GET_RECOMMEND_SUCCESS: {
            return Object.assign(Object.assign({}, state), { fetching: state.fetching > 0 ? state.fetching - 1 : 0, recommendedReservations: action.payload.recommendedReservations });
        }
        case GET_RECOMMEND_FAILURE: {
            return Object.assign(Object.assign({}, state), { error: action.payload.error, fetching: state.fetching > 0 ? state.fetching - 1 : 0 });
        }
        case GET_RECOMMEND_ID_REQUEST: {
            return Object.assign(Object.assign({}, state), { fetching: state.fetching + 1 });
        }
        case GET_RECOMMEND_ID_SUCCESS: {
            return Object.assign(Object.assign({}, state), { fetching: state.fetching > 0 ? state.fetching - 1 : 0, recommendedReservation: Object.assign({}, action.payload.recommendedReservation) });
        }
        case GET_RECOMMEND_ID_FAILURE: {
            return Object.assign(Object.assign({}, state), { error: action.payload.error, fetching: state.fetching > 0 ? state.fetching - 1 : 0 });
        }
        case POST_RESERVE_REQUEST: {
            return Object.assign(Object.assign({}, state), { fetching: state.fetching + 1 });
        }
        case POST_RESERVE_SUCCESS: {
            return Object.assign(Object.assign({}, state), { fetching: state.fetching > 0 ? state.fetching - 1 : 0, reservedConversation: Object.assign({}, action.payload.reservedConversation) });
        }
        case POST_RESERVE_FAILURE: {
            return Object.assign(Object.assign({}, state), { error: action.payload.error, fetching: state.fetching > 0 ? state.fetching - 1 : 0 });
        }
        case POST_REQUEST_CONVERSATIONS_REQUEST: {
            return Object.assign(Object.assign({}, state), { fetching: state.fetching + 1 });
        }
        case POST_REQUEST_CONVERSATIONS_SUCCESS: {
            return Object.assign(Object.assign({}, state), { fetching: state.fetching > 0 ? state.fetching - 1 : 0, reservedConversation: Object.assign({}, action.payload.reservedConversation) });
        }
        case POST_REQUEST_CONVERSATIONS_FAILURE: {
            return Object.assign(Object.assign({}, state), { error: action.payload.error, fetching: state.fetching > 0 ? state.fetching - 1 : 0 });
        }
        case GET_STUDENTS_REQUEST_CONVERSATIONS_REQUEST: {
            return Object.assign(Object.assign({}, state), { fetching: state.fetching + 1 });
        }
        case GET_STUDENTS_REQUEST_CONVERSATIONS_SUCCESS: {
            return Object.assign(Object.assign({}, state), { fetching: state.fetching > 0 ? state.fetching - 1 : 0, studentsRequestConversations: Object.assign({}, action.payload.studentsRequestConversations) });
        }
        case GET_STUDENTS_REQUEST_CONVERSATIONS_FAILURE: {
            return Object.assign(Object.assign({}, state), { error: action.payload.error, fetching: state.fetching > 0 ? state.fetching - 1 : 0 });
        }
        case DELETE_REQUEST_CONVERSATIONS_REQUEST: {
            return Object.assign(Object.assign({}, state), { fetching: state.fetching + 1 });
        }
        case DELETE_REQUEST_CONVERSATIONS_SUCCESS: {
            return Object.assign(Object.assign({}, state), { deletedRequestConversation: Object.assign({}, action.payload.deletedRequestConversation), fetching: state.fetching > 0 ? state.fetching - 1 : 0 });
        }
        case DELETE_REQUEST_CONVERSATIONS_FAILURE: {
            return Object.assign(Object.assign({}, state), { error: action.payload.error, fetching: state.fetching > 0 ? state.fetching - 1 : 0 });
        }
        case GET_STUDENTS_REQUEST_CONVERSATIONS_ID: {
            return Object.assign(Object.assign({}, state), { fetching: state.fetching > 0 ? state.fetching - 1 : 0, studentsRequestConversation: Object.assign({}, action.payload.studentsRequestConversation) });
        }
        case CLEAR_STUDENTS_REQUEST_CONVERSATIONS_ID: {
            return Object.assign(Object.assign({}, state), { fetching: state.fetching > 0 ? state.fetching - 1 : 0, studentsRequestConversations: null });
        }
        case GET_TEACHERS_REQUEST_CONVERSATIONS_REQUEST: {
            return Object.assign(Object.assign({}, state), { fetching: state.fetching + 1 });
        }
        case GET_TEACHERS_REQUEST_CONVERSATIONS_SUCCESS: {
            return Object.assign(Object.assign({}, state), { fetching: state.fetching > 0 ? state.fetching - 1 : 0, teachersRequestConversations: action.payload.teachersRequestConversations });
        }
        case GET_TEACHERS_REQUEST_CONVERSATIONS_FAILURE: {
            return Object.assign(Object.assign({}, state), { error: action.payload.error, fetching: state.fetching > 0 ? state.fetching - 1 : 0 });
        }
        case GET_TEACHERS_REQUEST_CONVERSATIONS_ID: {
            return Object.assign(Object.assign({}, state), { fetching: state.fetching > 0 ? state.fetching - 1 : 0, teachersRequestConversation: Object.assign({}, action.payload.teachersRequestConversation) });
        }
        case CLEAR_TEACHERS_REQUEST_CONVERSATIONS_ID: {
            return Object.assign(Object.assign({}, state), { fetching: state.fetching > 0 ? state.fetching - 1 : 0, teachersRequestConversations: null });
        }
        case POST_APPROVE_REQUEST_CONVERSATIONS_REQUEST: {
            return Object.assign(Object.assign({}, state), { fetching: state.fetching + 1 });
        }
        case POST_APPROVE_REQUEST_CONVERSATIONS_SUCCESS: {
            return Object.assign(Object.assign({}, state), { fetching: state.fetching > 0 ? state.fetching - 1 : 0, teachersRequestConversation: Object.assign({}, action.payload.teachersRequestConversation) });
        }
        case POST_APPROVE_REQUEST_CONVERSATIONS_FAILURE: {
            return Object.assign(Object.assign({}, state), { error: action.payload.error, fetching: state.fetching > 0 ? state.fetching - 1 : 0 });
        }
        case GET_TODAY_REQUEST: {
            return Object.assign(Object.assign({}, state), { fetching: state.fetching + 1 });
        }
        case GET_TODAY_SUCCESS: {
            return Object.assign(Object.assign({}, state), { fetching: state.fetching > 0 ? state.fetching - 1 : 0, todayConversations: action.payload.todayConversations });
        }
        case GET_TODAY_FAILURE: {
            return Object.assign(Object.assign({}, state), { error: action.payload.error, fetching: state.fetching > 0 ? state.fetching - 1 : 0 });
        }
        case GET_EVALUATION_CHECK_REQUEST: {
            return Object.assign(Object.assign({}, state), { fetching: state.fetching + 1 });
        }
        case GET_EVALUATION_CHECK_SUCCESS: {
            return Object.assign(Object.assign({}, state), { fetching: state.fetching > 0 ? state.fetching - 1 : 0, hasEvaluation: action.payload.hasEvaluation });
        }
        case GET_EVALUATION_CHECK_FAILURE: {
            return Object.assign(Object.assign({}, state), { error: action.payload.error, fetching: state.fetching > 0 ? state.fetching - 1 : 0 });
        }
        case SET_TIMER_ID: {
            return Object.assign(Object.assign({}, state), { timerId: action.payload.timerId });
        }
        case GET_NEXT_RESERVATION_TIME: {
            return Object.assign(Object.assign({}, state), { startTime: action.payload.startTime, endTime: action.payload.endTime });
        }
        default: {
            return state;
        }
    }
};
